module.exports = __webpack_public_path__ + "img/sib.dc647436.svg";